import './summary-count.scss';

interface SummaryCountProps {
  title: string;
  count: number;
  color: string;
  gridKey?: string;
  showDays?: boolean;
}
const SummaryCount: React.FC<SummaryCountProps> = ({ title, count, color, gridKey, showDays }: SummaryCountProps) => {
  return (
    <div className='summary-count__item' style={{ background: color }} key={gridKey}>
      <div className='count'>
        {count || 0} {showDays && 'days'}
      </div>
      <div className='title'>{title}</div>
    </div>
  );
};
export default SummaryCount;
